export default __webpack_public_path__ + "static/media/search_64x64.159901b5.svg";